// WhatsAppCallIcons.jsx
import React, { useState } from 'react';
import '../style.css';

const WhatsAppCallIcons = () => {
  const [showTooltip, setShowTooltip] = useState(null);
  
  // Your phone number
  const phoneNumber = "6307291567";
  const whatsappUrl = `https://wa.me/+91${phoneNumber}`;
  const callUrl = `tel:+91${phoneNumber}`;

  const handleCall = () => {
    window.open(callUrl, '_blank');
  };

  const handleWhatsApp = () => {
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="contact-icons-container">
      {/* WhatsApp Icon */}
      <div 
        className="icon-wrapper whatsapp-wrapper"
        onMouseEnter={() => setShowTooltip('whatsapp')}
        onMouseLeave={() => setShowTooltip(null)}
        onClick={handleWhatsApp}
      >
        {showTooltip === 'whatsapp' && (
          <div className="tooltip">Chat on WhatsApp</div>
        )}
        <div className="icon-circle whatsapp-circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="24" height="24">
            <path d="M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8z"/>
          </svg>
        </div>
      </div>

      {/* Call Icon */}
      <div 
        className="icon-wrapper call-wrapper"
        onMouseEnter={() => setShowTooltip('call')}
        onMouseLeave={() => setShowTooltip(null)}
        onClick={handleCall}
      >
        {showTooltip === 'call' && (
          <div className="tooltip">Call 6307291567</div>
        )}
        <div className="icon-circle call-circle">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="24" height="24">
            <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppCallIcons;